import { render, staticRenderFns } from "./drawerProjectsTaskEditAssign.vue?vue&type=template&id=3b2c71bc&"
import script from "./drawerProjectsTaskEditAssign.vue?vue&type=script&lang=js&"
export * from "./drawerProjectsTaskEditAssign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports